import React from 'react';
import Script from 'next/script';
import { localeToKlaviyoPublicMap } from '@rsc/utils/klaviyo';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

interface Props {
  block: {
    formId: string;
  };
}

export default function BlockBuilderKlaviyoEmbed({ block }: Readonly<Props>) {
  const { locale } = useUiComponentsInternationalContext();

  return (
    <div>
      {localeToKlaviyoPublicMap(locale, process.env.GATSBY_KLAVIYO_BRAND)
        .publicKey && (
        <Script
          key="klaviyo"
          src={`https://static.klaviyo.com/onsite/js/${
            localeToKlaviyoPublicMap(locale, process.env.GATSBY_KLAVIYO_BRAND)
              .publicKey
          }/klaviyo.js`}
          async
          onLoad={() => {
            const observer = new MutationObserver(
              (_mutations, mutationInstance) => {
                const klaviyoComponent = document.querySelector('.needsclick');

                if (klaviyoComponent) {
                  (klaviyoComponent as HTMLElement).style.zIndex = '15000';
                  mutationInstance.disconnect();
                }
              }
            );

            observer.observe(document, {
              childList: true,
              subtree: true,
            });
          }}
        />
      )}
      <div className="flex justify-center">
        <div className="max-w-3xl w-full">
          <div className={`klaviyo-form-${block.formId}`} />
        </div>
      </div>
    </div>
  );
}
